import type { Tutorial } from '../../shared/types.js';

export const agentsTutorial: Tutorial = {
  name: 'agents',
  title: 'Introduction to the Sessions page',
  description:
    'A quick tour of where your agent sessions live, how to find a specific run, and how to start a new agent.',
  category: 'agent-sessions',
  docPages: ['concepts/agents'],
  agenda: ['Browse your agent sessions', 'Find a specific run', 'Start a new agent'],
  steps: [
    {
      id: 'intro',
      kind: 'info',
      title: 'Welcome to Sessions',
      body: "This is your home base for background coding agents. From here you launch new agents and follow the ones already running. Let's take a 30-second look around.",
      path: '/runs',
    },
    {
      id: 'sidebar',
      kind: 'info',
      title: 'Your agent sessions',
      body: 'Every agent you launch shows up in this list, grouped by recency. Click one to open its live stream, send follow-up messages, or stop it.',
      target: '[data-tutorial-id="agent-sidebar"]',
      placement: 'right',
    },
    {
      id: 'filters',
      kind: 'info',
      title: 'Find a specific run',
      body: 'Once you have a lot of agents, filter the list by status, repository, time range, or a search query to jump straight to the one you need.',
      target: '[data-tutorial-id="agent-filter-bar"]',
      placement: 'bottom',
    },
    {
      id: 'new-agent',
      kind: 'info',
      title: 'Start a new agent',
      body: 'This is where every run begins. The **New agent** button opens the launch dialog.',
      target: '[aria-label="New agent"]',
      placement: 'right',
    },
    {
      id: 'done',
      kind: 'info',
      title: "That's the tour",
      body: 'You know your way around now. Ready to launch one? We can walk through the launch dialog together, step by step.',
    },
  ],
  handoff: { tutorialName: 'launch-agent', label: 'Launch your first agent' },
};
